var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "info-popup", width: 0 },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal modal__400 modal__info show",
          attrs: { id: "info_modal" }
        },
        [
          _c("section", [
            _c("a", { staticClass: "modal__close", on: { click: _vm.hide } }, [
              _c("i", { staticClass: "icon-close" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__head" }, [
              _vm.content.image
                ? _c("img", {
                    staticClass: "events-button",
                    attrs: { src: _vm.content.image, alt: "events button" }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__body" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.content.body) } })
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }